import { render, staticRenderFns } from "./PointPrograms.vue?vue&type=template&id=2d4607db&scoped=true&"
import script from "./PointPrograms.vue?vue&type=script&lang=js&"
export * from "./PointPrograms.vue?vue&type=script&lang=js&"
import style0 from "./PointPrograms.vue?vue&type=style&index=0&id=2d4607db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4607db",
  null
  
)

export default component.exports